export default ({ editableDescription, description, placeholder, onChange }) => {
  if (editableDescription) {
    return (
      <textarea className="form-control" name="description" value={description || ''} placeholder={placeholder} onChange={onChange} />
    )
  }

  return (<p>{description}</p>)
}
